import Image from 'next/image'
import { ASSET_PREFIX } from '~/constants/env'
import { StyledStatusArea } from './styled'

export enum TradeStatus {
  Success,
  Failed,
  Rejected,
  Timeout,
}

export const TradeStatusIcon = {
  [TradeStatus.Success]: `${ASSET_PREFIX}/images/success-checked.svg`,
  [TradeStatus.Timeout]: `${ASSET_PREFIX}/images/timeout_slicing.svg`,
  [TradeStatus.Failed]: `${ASSET_PREFIX}/images/failed.svg`,
  [TradeStatus.Rejected]: `${ASSET_PREFIX}/images/failed.svg`,
}

export interface ITradeStatusArea {
  status: TradeStatus
  size?: number
}

export const TradeStatusArea: React.FC<ITradeStatusArea> = ({
  status,
  size = 57,
  children,
}) => {
  return (
    <StyledStatusArea>
      <Image src={TradeStatusIcon[status]} width={size} height={size} />
      <div className="content">{children}</div>
    </StyledStatusArea>
  )
}
